import { FC } from 'react';
import dayjs from 'dayjs';

import { Badge, CustomAlert, Text } from '../../../../../../shared/uiComponents';
import { TEXT } from '../../../../../../shared/Helpers/colors';
import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import { BadgeTypes } from '../../../../../../shared/uiComponents/StatusBadge';
import { targetStatusType } from '../targetRow';
import GraphsTarget from './TargetGraph/graphsTarget';
import Edit from './EditTarget';
import TargetMenu from './targetMenu';

interface TargetDetailsModalProps {
	onClose: () => void;
	open: boolean;

	target: TargetProperties;
}

const TargetDetailsModal: FC<TargetDetailsModalProps> = ({ target, open, onClose }) => {
	const renderContent = () => (
		<div className="targetDetailsContent">
			<div className="targetDetailsSection">
				<Text title={target.name} type="plg" fontWeight="semiBold" color={TEXT.SECONDARY} />
				<Badge
					label={target.status.name.split(/(?=[A-Z])/).join(' ')}
					sizeType="md"
					type={targetStatusType[target.status.name] as BadgeTypes}
				/>
			</div>

			<div className="targetDetailsInfoCard">
				<div className="targetDetailsInfoRow">
					<Text title="Response rate" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text
						title={target.responsePercentage ? `${target.responsePercentage}%` : '-'}
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
				<div className="targetDetailsInfoRow">
					<Text title="Date opened" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text
						title={target.dateOpened ? dayjs(target.dateOpened).format('MM/DD/YYYY') : '-'}
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
				<div className="targetDetailsInfoRow">
					<Text title="Date mastered" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text
						title={target.dateMastered ? dayjs(target.dateMastered).format('MM/DD/YYYY') : '-'}
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
				<div className="targetDetailsInfoRow">
					<Text title="Target type" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={target.type.name} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsInfoRow">
					<Text title="Mastery type" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text title={target.masteryCriteria.name} type="pxs" color={TEXT.TERTIARY} />
				</div>
				<div className="targetDetailsInfoRow">
					<Text title="Consecutive days" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
					<Text
						title={target.consecutiveDays ? target.consecutiveDays.toString() : '-'}
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
				{target.targetInstructions && (
					<div className="targetDetailsInfoRow">
						<Text title="Target Instructions" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
						<Text title={target.targetInstructions} type="pxs" color={TEXT.TERTIARY} />
					</div>
				)}
				{target.sd && (
					<div className="targetDetailsInfoRow">
						<Text title="SD" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
						<Text title={target.sd} type="pxs" color={TEXT.TERTIARY} />
					</div>
				)}
				{target.goalName && (
					<div className="targetDetailsInfoRow">
						<Text title="Goal name" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
						<Text title={target.goalName} type="pxs" color={TEXT.TERTIARY} />
					</div>
				)}
				{target.errorCorrection && (
					<div className="targetDetailsInfoRow">
						<Text title="Error Correction" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
						<Text title={target.errorCorrection} type="pxs" color={TEXT.TERTIARY} />
					</div>
				)}
				{target.reinforcement && (
					<div className="targetDetailsInfoRow">
						<Text title="Reinforcement" type="psm" fontWeight="medium" color={TEXT.SECONDARY} />
						<Text title={target.reinforcement} type="pxs" color={TEXT.TERTIARY} />
					</div>
				)}
			</div>

			<div className="targetDetailsActions">
				<GraphsTarget targetId={target.id} targetName={target.name} type={target.type.id} isIcon={false} />
				<div className="targetDetailsActionsRight">
					<Edit item={target} programId={target.programId} />
					<TargetMenu target={target} />
				</div>
			</div>
		</div>
	);

	return <CustomAlert title="Target details" open={open} onClose={onClose} Content={renderContent} noPadding />;
};

export default TargetDetailsModal;
